import React from "react";
import { Container, Grid, keyframes } from "@mui/material";
import styled from "@emotion/styled";
import { Heading, MainDiv, SectionHeading, SectionWrapper } from "../../../Styles/style";


import Icontelegram from "../../../../assets/images/btelegram.png"
import Twitter from "../../../../assets/images/btwitter.png"

import { P, ContentDiv, GridTextCentered, ParaDiv, } from "../../../Styles/style";

const A = styled.a`
text-decoration: none;
/* box-shadow: 1px 1px 1px 1px #dff */
;
`;
const InuImg = styled.img`
width:100%;
max-width:300px;
`;
const pressAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
`;
const SOcialimg = styled.a`
   color: #000;
font-family: "P-SM";
background: ${(props) => (props.bgcolor ? props.bgcolor : "#6FAE5F")};
padding: 17px 14px 8px;
border:4px solid #000;
box-shadow:inset 0px 1px 8px #ffffff91,-6px 5px 1px 1px #000;
text-decoration: none;
&:active {
    box-shadow: none;
    transform: scale(0.9);
    box-shadow: inset 0px 1px 8px #ffffff91;
  }

  animation: ${props => props.pressed ? pressAnimation : null} 0.3s ease-in-out;

`;
const GridWrapper = styled(Grid)`
display:flex;
justify-content:center;
  border: 1px solid transparent;
  padding:0;
  margin:0;
  /* border-radius: 15px; */
    `


const Index = () => {
  return (
    <SectionWrapper p="4rem 0"  align="center" bgColor="#E6BD23">
      <Container maxWidth="xl">
        <SectionHeading align="center" fs="60px" data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-offset="0"
                data-aos-duration="500">Join the Community</SectionHeading>
        <Heading align="center" data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-offset="0"
                data-aos-duration="500">Join our Socials!</Heading>
                <Heading align="center" data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-offset="0"
                data-aos-duration="500">info@pehpeh.vip</Heading>
      <ContentDiv>
        <SOcialimg href="https://twitter.com/pehpehcoineth" target="blank" data-aos="fade-up"
          data-aos-anchor-placement="top-bottom"
          data-aos-delay="400"
          data-aos-offset="0"
          data-aos-duration="500" ><img src={Twitter} width="26px" height="22px" /></SOcialimg>
        <SOcialimg href="https://t.me/pehpehcoineth" target="blank" data-aos="fade-up"
          data-aos-anchor-placement="top-bottom"
          data-aos-delay="500"
          data-aos-offset="0"
          data-aos-duration="500"><img src={Icontelegram} width="26px" height="22px" /></SOcialimg>
       
      </ContentDiv>
      </Container>
    </SectionWrapper>
  );
};

export default Index;
